import React from 'react';
import clsx from 'clsx';

/** Standard width container */
const Container = ({ className, children, as: Component = 'div', ...rest }) => (
  <Component className={clsx('max-w-6xl mx-auto px-4 sm:px-6 lg:px-8', className)} {...rest}>
    {children}
  </Component>
);

export default Container;
